import type { Margins } from "#public"

/**
 * Rotate margins 90° counter-clockwise: each edge takes the value of the next
 * one clockwise, so the amount that stood on the right ends up on top.
 *
 * Mirrors Python `MarginMeasureSet.rotate_fields()` (no reverse).
 */
export const RotateMarginsLeft = <T>(p: Margins<T>): Margins<T> => ({
  top: p.right,
  right: p.bottom,
  bottom: p.left,
  left: p.top,
})
